import React from "react";
import BsyUser from "../BsyUser";
import BsyIconBtn from "../BsyIconBtn";
import { BsyUtils } from "../../utils/Utils";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyWidget } from "../BsyWidget";

export class SingPage extends BsyWidget {
  constructor(props) {
    super(props);
    this.state = {};
    this.value = {
      flowAction: "sign_before",
      sign_candidates: [],
    };
    if (props.allowSignTypes.indexOf(2) > -1) {
      this.value.flowAction = "sign_parallel";
    }
  }

  getValue = () => {
    return this.value;
  };

  selectValue = (val) => {
    this.value.flowAction = val;
    this.setState({});
  };

  render() {
    const { allowSignTypes } = this.options;
    const { value } = this;
    let that = this;

    return (
      <div className="bsy_flow_Sign_pane" ref={this.element}>
        <div className="flow-sign-block">
          <div className="flow-sign-title">
            <span className="red">*</span>
            {React.language("flow.sign.pane.black1.title")}
          </div>
          <div className="flow-sign-content x-group">
            {allowSignTypes.indexOf(0) > -1 ? (
              <div
                className={
                  "group_item x-radio sign_before  " +
                  (value.flowAction == "sign_before" ? "select" : "")
                }
                tabIndex="-1"
                onClick={() => {
                  this.selectValue("sign_before");
                }}
              >
                <i className="icon-blank"></i>
                <span className="radio-text">
                  <div className="title">
                    {React.language("flow.sign.pane.black1.type1")}
                  </div>
                  <div className="desc">
                    {React.language("flow.sign.pane.black1.type1.desc")}
                  </div>
                </span>
              </div>
            ) : (
              ""
            )}
            {allowSignTypes.indexOf(1) > -1 ? (
              <div
                className={
                  "group_item x-radio sign_after " +
                  (value.flowAction == "sign_after" ? "select" : "")
                }
                tabIndex="-1"
                onClick={() => {
                  this.selectValue("sign_after");
                }}
              >
                <i className="icon-blank"></i>
                <span className="radio-text">
                  <div className="title">
                    {React.language("flow.sign.pane.black1.type2")}
                  </div>
                  <div className="desc">
                    {React.language("flow.sign.pane.black1.type2.desc")}
                  </div>
                </span>
              </div>
            ) : (
              ""
            )}
            {allowSignTypes.indexOf(2) > -1 ? (
              <div
                className={
                  "group_item x-radio sign_parallel " +
                  (value.flowAction == "sign_parallel" ? "select" : "")
                }
                tabIndex="-1"
                onClick={() => {
                  this.selectValue("sign_parallel");
                }}
              >
                <i className="icon-blank"></i>
                <span className="radio-text">
                  <div className="title">
                    {React.language("flow.sign.pane.black1.type3")}
                  </div>
                  <div className="desc">
                    {React.language("flow.sign.pane.black1.type3.desc")}
                  </div>
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="flow-sign-block">
          <div className="flow-sign-title">
            <span className="red">*</span>
            {React.language("flow.sign.pane.black2.title")}
          </div>
          <BsyUser
            appId={this.props.appId}
            is_dock_form={this.props.is_dock_form}
            onStopEdit={(e) => {
              if (e) {
                this.value.sign_candidates = [e];
              } else {
                this.value.sign_candidates = [];
              }
            }}
          ></BsyUser>
        </div>
        <div className="flow-sign-block" style={{ marginTop: 60 }}>
          <BsyIconBtn
            text={React.language("ok")}
            type="blue"
            click={() => {
              let signValue = that.getValue();
              if (BsyUtils.isObjectEmpty(signValue.flowAction)) {
                tipAlert({
                  type: "warning",
                  msg: React.language("flow.sign.pane.black1.tip"),
                });
                return;
              }

              if (BsyUtils.isObjectEmpty(signValue.sign_candidates)) {
                tipAlert({
                  type: "warning",
                  msg: React.language("flow.sign.pane.black2.tip"),
                });

                return;
              }

              this.props.onStopEdit(signValue);
            }}
            mode={window.mode}
          ></BsyIconBtn>
          <BsyIconBtn
            text={React.language("cancel")}
            type="white"
            click={() => {
              this.props.onClose();
            }}
            mode={window.mode}
          ></BsyIconBtn>
        </div>
      </div>
    );
  }
}
